import React, { useEffect } from 'react'
import { ElementProps } from '../base/element'
import {
  IComponent,
  IDataComponent,
  IDefaultStyles,
  ISelectItemArrayFunction,
  ISelectOptionItem,
  IStringArrayFunction,
  IStyles
} from '../schemamanager/types'
import { EventType } from '../schemamanager/schemaManager'

export interface IRadioGroupComponent extends IDataComponent {
  type: 'radiogroup'
  options: string[] | ISelectOptionItem[] | IStringArrayFunction | ISelectItemArrayFunction
  styleInputGroup?: IStyles
  styleInput?: IStyles
  styleLabel?: IStyles
}

export const RadioGroup = (props: ElementProps) => {
  const { sm, themeColor, events, data, addProps } = props
  const comp = props.comp as IRadioGroupComponent
  // const rgname = comp.field + '_' + Math.floor(Math.random() * 10000).toString()

  const ref: any = React.useRef()
  const defaultValue = data.value()
  const [editValue, setEditValue] = React.useState(defaultValue)


  const options: ISelectOptionItem[] = sm.selectOptionsAsObjects(comp)

  const doFocus = (compToFocus: IComponent) => {
    if (compToFocus === comp) {
      ref.current?.focus()
    }
  }

  useEffect(() => {
    sm.on(EventType.FocusComponent, doFocus)
    return () => {
      sm.removeListener(EventType.FocusComponent, doFocus)
    }
  }, [sm])

  const handleChange = (event: any) => {
    let value = event.target.value
    if (comp.dataType === 'int') {
      value = parseInt(value);
    }
    setEditValue(value)
    data.updateValue(value)

    if (events().onChange) {
      events().onChange({ sm, comp, value })
    }
  }

  const style: IDefaultStyles = {
    main: {
      classes: {
        margin: 'mt-1 ml-2',
        display: 'flex',
        flexDirection: 'flex-col'
      }
    },
    styleInput: {
      classes: {
        height: 'h-5',
        width: 'w-5',
        textColor: themeColor().textColor
      },
      class: 'disabled:opacity-50'
    },
    styleLabel: {
      classes: {
        margin: 'ml-2',
        textColor: 'text-gray-700'
      }
    },
    styleInputGroup: {
      classes: {
        margin: 'mt-2 mr-4',
        display: 'flex',
        alignItems: 'items-center'
      }
    }
  }

  const m = props.mergeStyles(style)


  return (
    <div {...m.main} {...events()}>
      {options.map((o, ind) => {
        const key = comp.field + '_' + o.value + '_' + ind
        const r = ind === 0 ? ref : undefined
        return (
          <div key={key} {...m.styleInputGroup}>
            <input
              ref={r}
              type='radio'
              value={o.value}
              checked={editValue === o.value}
              onChange={handleChange}
              {...m.styleInput}
              {...addProps()}
            />
            <span {...m.styleLabel}>{o.label}</span>
          </div>
        )
      })}
    </div>
  )
}
